import _ from "underscore";
import $ from "jquery";
import {setElementsFromScope, show, hide, insertTextAndClean, combineElements, setUniqNamesAndIds} from "../../utilities/selectorHelpers";
import {createPreventDefault, isPresent, isTruthy, isBlank} from '../../utilities/general';

const elementsMap = {
  originFacilitySelect: '.origin-facility',
  destinationFacilitySelect: '.destination-facility',
  originFacAddress: '.origin-fac-address',
  originFacilityWrapper: '.origin-fac-address-wrapper',
  originFacilityUses: '.origin-fac-uses-list',
  destFacAddress: '.dest-fac-address',
  destFacAddressWrapper: '.dest-fac-address-wrapper',
  destFacilityUses: '.dest-fac-uses-list'
};

export default function FacilitiesTab(wizard){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const els = {};
  const facilitiesList = wizardElement.data('facilities');

  self.init = function(){
    render();
  };

  function render(){
    setElements();
    loadDropDowns();
    bindElements();
  }

  function setElements() {
    setElementsFromScope(els, elementsMap, wizardElement);
  }

  function bindElements() {
    els.originFacilitySelect.on("change", handleOriginFacilityChangeEvent);
    els.destinationFacilitySelect.on("change", handleDestinationFacilityChangeEvent);
  }

  function loadDropDowns() {
    $(facilitiesList).each(function() {
      const option = $('<option />');
      option.attr('value', this.facId).text(this.facName);
      els.originFacilitySelect.append(option);
    });    

    $(facilitiesList).each(function() {
      const option = $('<option />');
      option.attr('value', this.facId).text(this.facName);
      els.destinationFacilitySelect.append(option);
    });    
  }

  function handleOriginFacilityChangeEvent(e) {
    e.preventDefault();
    const selectedFacility = this.value;
    const facility = facilitiesList.filter(function(obj) {
      return obj.facId==selectedFacility; }) [0];
    //show address
    els.originFacilityWrapper.hide();
    els.originFacAddress.html('');
    if (facility != null) {
      //$("#"+portletNamespace+"facId").val(facility.facId);
      els.originFacAddress.append("<div>"+facility.facAddressLine1+"</div>");
      if(facility.facAddressLine2 != null){
        els.originFacAddress.append("<div>"+facility.facAddressLine2+"</div>");
      }
      els.originFacAddress.append("<div>"+facility.facCity+", "+facility.facState+" "+facility.facZipcode+"</div>");
      //show facility/fulfillment uses
      els.originFacilityUses.html("");
      els.originFacilityUses.append("<div class='q-boldest'>Facility Uses:</div>");
      var facilityUses = false;
      if(facility.attributes != null && facility.attributes.length > 0){
        $.each(facility.attributes[0],function(key, value) {
          if(key == "IN" && value == true){
            els.originFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>International Fulfillment Center</span> ");
            facilityUses = true;
          }else if(key == "FC" && value == true){
            els.originFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Fulfillment Center</span> ");
            facilityUses = true;
          }else if(key == "DC" && value == true){
            els.originFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Distribution Center</span> ");
            facilityUses = true;
          }else if(key == "RC" && value == true){
            els.originFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Returns Center</span> ");
            facilityUses = true;
          }
        });
        if(!facilityUses){
          els.originFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
        }
      }else{
        els.originFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
      }
      els.originFacilityWrapper.show();
    }
  }

  function handleDestinationFacilityChangeEvent(e) {
    e.preventDefault();
    const selectedFacility = this.value;
    const facility = facilitiesList.filter(function(obj) {
      return obj.facId==selectedFacility; }) [0];
    //show address
    els.destFacAddressWrapper.hide();
    els.destFacAddress.html('');
    if (facility != null) {
      //$("#"+portletNamespace+"facId").val(facility.facId);
      els.destFacAddress.append("<div>"+facility.facAddressLine1+"</div>");
      if(facility.facAddressLine2 != null){
        els.destFacAddress.append("<div>"+facility.facAddressLine2+"</div>");
      }
      els.destFacAddress.append("<div>"+facility.facCity+", "+facility.facState+" "+facility.facZipcode+"</div>");
      //show facility/fulfillment uses
      els.destFacilityUses.html("");
      els.destFacilityUses.append("<div class='q-boldest'>Facility Uses:</div>");
      var facilityUses = false;
      if(facility.attributes != null && facility.attributes.length > 0){
        $.each(facility.attributes[0],function(key, value) {
          if(key == "IN" && value == true){
            els.destFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>International Fulfillment Center</span> ");
            facilityUses = true;
          }else if(key == "FC" && value == true){
            els.destFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Fulfillment Center</span> ");
            facilityUses = true;
          }else if(key == "DC" && value == true){
            els.destFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Distribution Center</span> ");
            facilityUses = true;
          }else if(key == "RC" && value == true){
            els.destFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Returns Center</span> ");
            facilityUses = true;
          }
        });
        if(!facilityUses){
          els.destFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
        }
      }else{
        els.destFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
      }
      els.destFacAddressWrapper.show();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/transferOrder/FacilitiesTab.js